import { BASE_URL } from "@/constants/config";
import { request } from "@/utils/request";

export const BRANCHES_ENDPOINTS = {
  branches_list: `${BASE_URL}api/branches/`,
  export: `${BASE_URL}api/branches/export`,
  branch_details: (branch_id) => `${BASE_URL}api/branches/${branch_id}/`,
};

class Branches {
  async getBranchList() {
    const { data } = await request({
      url: BRANCHES_ENDPOINTS.branches_list,
    });
    return data;
  }

  async createBranch(branchData) {
    const { data } = await request({
      url: BRANCHES_ENDPOINTS.branches_list,
      method: "POST",
      body: branchData,
    });
    return data;
  }

  async updateBranch(branch_id, branchData) {
    const { data } = await request({
      url: BRANCHES_ENDPOINTS.branch_details(branch_id),
      method: "PUT",
      body: branchData,
    });
    return data;
  }

  async deleteBranch(branch_id) {
    const { data } = await request({
      url: BRANCHES_ENDPOINTS.branch_details(branch_id),
      method: "DELETE",
    });
    return data;
  }
}

export const BranchesServices = new Branches();
